/**
 * Angular import.
 */
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
/**
 * Service imports.
 */
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { GetService } from '../../../dataservices/get.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
/**
 * Interface import.
 */
import { CommunityMembersResponse } from '../../../onboarding/interface/apiResponse.model';

/**
 * Constant imports.
 */
import { NUMBERS, SCREEN_NAME } from '../../../constants/app.constants';
import { CommunityMember, MemberCountData } from '../../../onboarding/interface/global.model';
/**
 * Rxjs import.
 */
import { Subscription } from 'rxjs';

/**
 * Component used to show members of communuity.
 */
@Component({
  selector: 'app-community-member-filter-connections',
  templateUrl: './community-member-filter-connections.component.html',
  styleUrls: ['./community-member-filter-connections.component.scss']
})

export class CommunityMemberFilterConnectionsComponent implements OnChanges, OnDestroy {
  /**
   * Member list.
   */
  public memberList: CommunityMember[] = [];
  /**
   * Used this for laoder.
   */
  public finished = false;
  /**
   * Offset for member list.
   */
  public offset = NUMBERS.ONE;
  /**
   * Use to show when internet connection is broken on scroll.
   */
  public isInfoModalShown = false;
  /**
   * Message for info modal.
   */
  public info_msg: string;
  /**
   * Community id.
   */
  public communityId = '';
  /**
   * Filter type for connection
   */
  @Input() filterType: string;
  /**
   * Meber count and text for member list.
   */
  @Input() memberCountData: MemberCountData;

  public numberZero = NUMBERS.ZERO;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Screen name.
   */
  public callingFrom = SCREEN_NAME.COMMUNITY_DETAILS;

  /**
   * Necessary instances
   */
  constructor(
    private getApiAervice: GetService,
    public fcs: FunCollectionService,
    public masterService: MasterserviceService,
    public mls: NewLanguageService,
    public route: ActivatedRoute
  ) {
    /**
     * Get community ID.
     */
    this.communityId = this.route.snapshot.params['communityId'];
  }

  /**
   * When we change member filter type.
   */
  ngOnChanges(): void {
    if (this.filterType || this.filterType === '') {
      this.memberList = [];
      this.offset = 1;
      this.getMembersList();
    }
  }

  /**
   * Get community member list.
   */
  getMembersList(): void {
    this.finished = true;
    this.subscriptions.add(this.getApiAervice.getCommunityMembers('', this.communityId, this.offset, this.filterType).subscribe((res: CommunityMembersResponse) => {
      this.finished = false;
      if (res.status === NUMBERS.ONE) {
        this.memberList = this.memberList.concat(res.data.members);
        this.offset = res.data.offset;
        if (this.offset === 2) {
          this.getMembersList();
        }
      } else {
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err)));
  }

  /**
   * reset Info Modal
   */
  resetInfoModal(): void {
    this.isInfoModalShown = false;
  }

  /**
   * on scroll function called
   */
  onScroll(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    if (this.offset > 1) {
      this.getMembersList();
    }
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
